import classNames from "classnames";
import SezzleWidget from "component/design-system/bnpl-widget/sezzleWidget";
import HideIf from "util/HideIf";
import { LINE_PAGES } from "util/product/product-constants";
import ProductPrice from "../product-price/ProductPrice";
import ProductRewardsBadge from "../product-rewards/ProductRewardsBadge";
import styles from "./ProductHeaderDetail.module.scss";

interface Props {
  pageType: string;
  price: number;
  wasPrice: number;
  maximumPrice?: number;
  minimumPrice?: number;
  corePrice?: number;
  fromSideMenu?: boolean;
  displayInOneLine?: boolean;
  className?: string;
  productSku: string;
  isCompact?: boolean;
  rewardsAfterPrice?: boolean;
}
function ProductPagePrice(props: Props) {
  const {
    price, wasPrice, maximumPrice, minimumPrice, corePrice, fromSideMenu, pageType, displayInOneLine, className = "",
    productSku, isCompact = false, rewardsAfterPrice = false,
  } = props;
  return (
    <div className={classNames("m-b-10", {
      [styles.sidemenu_price_container]: fromSideMenu,
    })}
    >
      <div className={classNames(styles.product_price_container, className)}>
        <ProductPrice
          {...{
            price,
            wasPrice,
            maximumPrice,
            minimumPrice,
            corePrice,
          }}
          size="large"
          productPriceClassName={LINE_PAGES.includes(pageType) ? styles.productPriceRangeClassName : styles.productPriceClassName}
          displayInOneLine={displayInOneLine}
          color="#000000"
          productSku={productSku}
          sameSize
          isCompact={isCompact}
          rewardsAfterPrice={rewardsAfterPrice}
        />

      </div>
      <SezzleWidget price={price} className={styles.sezzle_widget} />
      <HideIf show={isCompact}>
        <ProductRewardsBadge sku={productSku} />
      </HideIf>
    </div>

  );
}

export default ProductPagePrice;
